import { css } from '@wanteddev/wds-engine';
import { variantMap, getWeightMap } from '../components/typography/style.mjs';

// src/utils/typography.ts
var typographyStyle = (variant, weight) => css`
  ${variantMap[variant]};
  ${weight && getWeightMap(variant)[weight]};
`;
var ellipsisTypographyStyle = (line = 1) => line === 1 ? css`
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      ` : css`
        overflow: hidden;
        position: relative;
        /* stylelint-disable */
        display: -webkit-box;
        -webkit-line-clamp: ${line};
        -webkit-box-orient: vertical;
        /* stylelint-enable */
      `;
var listStyle = css`
  list-style-type: disc;
  padding-left: 1.5em;

  ul {
    list-style-type: circle;
    padding-left: 1.5em;
  }

  li::marker {
    font-size: 0.8em;
  }
`;

export { ellipsisTypographyStyle, listStyle, typographyStyle };
